// Description: Endpoint to update the profile info
// Updated: 08/09/2025
// Author: Simon Franklin

import { getTokenData } from "../../../shared/utils/utils";

export async function FinishRegister(infoData) {
    try {
        const { token, client_id } = await getTokenData();

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!client_id) throw new Error('ID do cliente não encontrado');

        const response = await fetch(`${process.env.REACT_APP_BACKEND_AWS_URL}/profile/info`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    'Client_ID': `${client_id}`
                },
                body: JSON.stringify(infoData)
            }
        );
        
        const data = await response.json();

        return data;
    } catch (error) {
        return error.response?.data ?? {
            status: 'error',
            message: 'Erro ao atualizar perfil.'
        };
    }
}
